import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { VTableModule } from "@app/directives/_layout/v-table/v-table.module";
import { MapDirectivesModule } from "@app/directives/_map/_map.directives.module";
import { ResourceFiltersDirectivesModule } from "@app/directives/_resourceFilters/_resourceFilters.directives.module";
import { ResourceManagementModule } from "@app/main/components/resourceManagement/resourceManagement.module";
import { StreamaxConfigsAccountListComponent } from "@app/main/modules/foundation/_routes/streamax-configs/account-list/streamax-configs-account-list.component";
import { CustomTriggerMetrics } from "@app/main/modules/foundation/_routes/streamax-configs/custom-trigger-metrics/custom-trigger-metrics.component";
import { StreamaxConfigProfileEditor } from "@app/main/modules/foundation/_routes/streamax-configs/profiles/streamax-config-profile-editor.component";
import { StreamaxConfigsComponent } from "@app/main/modules/foundation/_routes/streamax-configs/streamax-configs-account-view.component";
import { StreamaxConfigsDeviceList } from "@app/main/modules/foundation/_routes/streamax-configs/streamax-configs-device-list/streamax-configs-device-list.component";
import { DeviceProfileVehicleSummaryComponent } from "@app/main/modules/foundation/_routes/streamax-configs/streamax-configs-vehicle-summary/streamax-configs-vehicle-summary.component";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { VehicleDirectivesModule } from "../../../../../directives/_vehicle/_vehicle.directives.module";
import { FoundationComponentsModule } from "../../_components/components.modules";

const privateComponents: any[] = [
];

const publicComponents: any[] = [
    StreamaxConfigsComponent,
    StreamaxConfigsAccountListComponent,
    StreamaxConfigProfileEditor,
    CustomTriggerMetrics,
    StreamaxConfigsDeviceList,
    DeviceProfileVehicleSummaryComponent
];

const declarations: any[] = [
];

const providers: any[] = [

];

@NgModule({
    imports: [
        CommonModule,
        PipesModule,
        FormsModule,
        FormsDirectivesModule,
        ReactiveFormsModule,
        VeriDirectivesModule,
        VehicleDirectivesModule,
        MiscDirectivesModule,
        LayoutDirectivesModule,
        CoreDirectivesModule,
        VTableModule,
        ResourceFiltersDirectivesModule,
        ResourceManagementModule,
        FoundationComponentsModule,
        MapDirectivesModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class StreamaxConfigsModule {
    constructor() {
    }
}
